import script from "./IncidentDetailComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./IncidentDetailComponent.vue?vue&type=script&setup=true&lang=ts"

import "./IncidentDetailComponent.vue?vue&type=style&index=0&id=4ff98252&lang=scss"

const __exports__ = script;

export default __exports__